'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Form = require('./layout/Form');

var _Form2 = _interopRequireDefault(_Form);

var _Row = require('./layout/Row');

var _Row2 = _interopRequireDefault(_Row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var standardLayout = {
  form: _Form2.default,
  row: _Row2.default
};

exports.default = standardLayout;


/** WEBPACK FOOTER **
 ** ../biro/lib/library/standard/layout.js
 **/